import React from 'react'
import { useIntl } from 'react-intl'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useRoles } from '../../../../../hooks/userRoleContext'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { roles } = useRoles()

  // Verifica se l'utente ha il ruolo 'admin'
  const isOwner = roles ? roles.includes('Proprietario') : false
  const isAdmin = roles ? roles.includes('Admin') : false
  const isManager = roles ? roles.includes('Gestore') : false
  const isDeveloper = roles ? roles.includes('Sviluppatore') : false
  const isViewer = roles ? roles.includes('Operatore') : false


  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        icon='/media/icons/duotune/layouts/lay001.svg'
        fontIcon='bi-app-indicator'
      />

      {/* Deploy */}
      {(isOwner || isAdmin || isManager || isDeveloper || isViewer) && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Deploy</span>
        </div>
      </div>
      )}

      {/* Visori */}
      {(isOwner || isAdmin || isManager || isDeveloper || isViewer) && (
      <SidebarMenuItem
        to='/visori'
        title='Visori'
        icon='/media/icons/duotune/technology/teh006.svg'
        fontIcon='bi-archive'
      />
      )}

      {/* Libreria */}
      {/*{(isOwner || isAdmin || isManager || isDeveloper || isViewer) && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Libreria</span>
        </div>
      </div>
      )}*/}

      {/* Simulazioni VR */}
      {/*{(isOwner || isAdmin || isManager || isDeveloper) && (
      <SidebarMenuItemWithSub
        to='#'
        title='Simulazioni VR'
        icon='/media/icons/duotune/general/gen008.svg'
        fontIcon='bi-archive'
      >
        <SidebarMenuItem to='/inserisci-visore' title='Inserisci' hasBullet={true} />
        <SidebarMenuItem to='/libro-mastro' title='Libro mastro' hasBullet={true} />
      </SidebarMenuItemWithSub>
      )}*/}

      {/* Files */}
      {/*{(isOwner || isAdmin || isManager || isDeveloper) && (
      <SidebarMenuItemWithSub
        to='#'
        title='Files'
        icon='/media/icons/duotune/files/fil012.svg'
        fontIcon='bi-archive'
      >
        <SidebarMenuItem to='/inserisci-visore' title='Inserisci' hasBullet={true} />
        <SidebarMenuItem to='/libro-mastro' title='Libro mastro' hasBullet={true} />
      </SidebarMenuItemWithSub>
      )}*/}

      {/* Mirroring */}
      {(isOwner || isAdmin || isManager || isDeveloper || isViewer) && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Mirroring</span>
        </div>
      </div>
      )}

      {(isOwner || isAdmin || isManager || isDeveloper || isViewer) && (
      <SidebarMenuItem
        to='/multi-view'
        title='Multiview'
        icon='/media/icons/duotune/technology/teh007.svg'
        fontIcon='bi-archive'
      />
      )}

      {/* Modalità */}
      {/*<SidebarMenuItemWithSub
        to='#'
        title='Modalità'
        icon='/media/icons/duotune/technology/teh007.svg'
        fontIcon='bi-archive'
      >*/}
        {/*<SidebarMenuItem to='/multi-view' title='Multiview' hasBullet={true} />*/}
        {/*<SidebarMenuItem to='/conferenza' title='Conferenza' hasBullet={true} />*/}
      {/*</SidebarMenuItemWithSub>*/}


      {/*Impostazioni*/}
      {(isOwner || isAdmin) && (
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Impostazioni</span>
        </div>
      </div>
      )}

      {/* Impostazioni - solo per admin */}
      {(isOwner || isAdmin) && (
        <>
          <SidebarMenuItemWithSub
            to='#'
            title='Console Admin'
            fontIcon='bi-archive'
            icon='/media/icons/duotune/general/gen051.svg'
          >
            <SidebarMenuItem to='/gestione-utenti' title='Gestione utenti' hasBullet={true} />
          </SidebarMenuItemWithSub>
        </>
      )}
    </>
  )
}

export { SidebarMenuMain }
